import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store";
import { SortDescriptor } from "@progress/kendo-data-query";
import { clearAdminEwgData, getAdminEwgData } from "../../store/slices/ewg";
import {
  AdminContentWrapper,
  AdminHeader,
  Loader,
  TableGrid,
  TableLastItem,
} from "../../components";
import { format } from "date-fns";
import { GridColumn } from "@progress/kendo-react-grid";
import appConfig from "../../util/appConfig";
import { statuses } from "../AdminSperrmuelanmeldungen";

export const ewgStatuses: { [key: string]: string } = {
  ...statuses,
  plausibilityCheck: "Plausibilitätsprüfung",
};

const AdminEwg = () => {
  const dispatch = useAppDispatch();
  const { isAdminLoaderActive } = useAppSelector((state) => state.admin);
  const {
    admin: { ewgData, ewgDataTotalCount },
  } = useAppSelector((state) => state.ewg);

  const [sort, setSort] = useState<Array<SortDescriptor>>([]);
  const [value, setValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [datesChanged, setDatesChanged] = useState({});
  const [status, setStatus] = useState<string[]>([]);

  const onDateChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (end || end === null) {
      setDatesChanged({ updated: true });
    }
  };

  const changeHandler = (val: string) => {
    setValue(val);
  };

  const pageChangeHandler = (page: number) => {
    setPage(page);
  };

  const pageSizeHandler = (size: number) => {
    setPage(1);
    setPageSize(size);
  };

  const changeStatuses = (st: string[]) => {
    setStatus([...st]);
  };

  const selectorOptions = [
    {
      placeholder: "Bitte Status wählen",
      isActive: ["awl"].includes(appConfig.logo),
      default: {},
      selectOptions: [
        { label: ewgStatuses.check, value: "check" },
        { label: ewgStatuses.accepted, value: "accepted" },
        { label: ewgStatuses.plausibilityCheck, value: "plausibilityCheck" },
      ],
      value: status.map((el) => {
        return {
          value: el,
          label: ewgStatuses[el],
        };
      }),
      onChange: changeStatuses,
    },
  ];

  useEffect(() => {
    const abortController = new window.AbortController();
    const signal = abortController.signal;

    dispatch(
      getAdminEwgData({
        signal,
        direction: sort[0]?.dir,
        page,
        pageSize,
        searchValue: value,
        sort: sort[0]?.field,
        startDate: startDate ? new Date(startDate).toUTCString() : startDate,
        endDate: endDate ? new Date(endDate).toUTCString() : endDate,
        status,
      }),
    );

    return () => {
      if (signal && abortController.abort) {
        abortController.abort();
      }
    };
  }, [sort, page, pageSize, value, datesChanged, status]);

  useEffect(() => {
    return () => {
      dispatch(clearAdminEwgData());
    };
  }, []);

  return (
    <div>
      <AdminHeader pageTitle={"Einwohnergleichwert"} hasBtnGroup={false} />
      <AdminContentWrapper>
        <TableGrid
          data={ewgData.map((el) => {
            return {
              ...el,
              createdAt: format(new Date(el.createdAt), "dd.MM.yyyy HH:mm"),
              location: `${el.street}, ${el.homeNumber}`,
              status: ewgStatuses[el.status!],
            };
          })}
          items={[
            { field: "createdAt", title: "Datum" },
            { field: "aktenzeichen", title: "Aktenzeichen" },
            { field: "email", title: "Email" },
            { field: "location", title: "Grundstück" },
            { field: "place", title: "Ort" },
            { field: "status", title: "Status" },
          ]}
          sort={sort}
          sortable={true}
          onSortChange={setSort}
          searchInputValue={value}
          onSearchInputValueChange={changeHandler}
          withPager={true}
          page={page}
          pageSize={pageSize}
          pageChangeHandler={pageChangeHandler}
          pageSizeHandler={pageSizeHandler}
          itemsCount={ewgDataTotalCount}
          onDateChange={onDateChange}
          startDate={startDate}
          endDate={endDate}
          withDatePicker
          lastItem={<GridColumn cell={TableLastItem} width="50px" />}
          selectorOptions={selectorOptions}
        />
      </AdminContentWrapper>
      {isAdminLoaderActive && <Loader />}
    </div>
  );
};

export default AdminEwg;
